import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FriendlyCaptchaService } from './common/friendly-captcha.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
              private friendlyCaptchaService: FriendlyCaptchaService) {
  }

  ngOnInit() {
    this.redirectHashUrl();
    this.friendlyCaptchaService.startFriendlyCaptcha();
  }

  /**
   * Workaround ist nötig nach Umstellung von useHash auf false im RoutingModule.
   * Hierdurch funktionieren existierende Links und Lesezeichen, die den Hash # enthalten weiterhin.
   *
   * @private
   */
  private redirectHashUrl() {
    // Überprüfe, ob die URL einen Hash enthält
    if (window.location.hash) {
      // Extrahiere den Pfad aus dem Hash
      const path = window.location.hash.substring(1);
      // Leite zur extrahierten URL weiter
      this.router.navigateByUrl(path);
    }
  }
}
